import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Report from './Component/Report';


const mapStateToProps = (state, ownProps) => ({
    currentProgram: state.organization.currentProgram,    
    programs: state.organization.programs,
    startNodeMap: state.organization.startNodeMap,
    htmlContent: state.organization.htmlContent,
    studentId: ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.hsgId || null,
    startNodeId: ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.startNodeId || null,
    dmftIndex: state.organization.dmftIndex && state.organization.dmftIndex.length ? state.organization.dmftIndex : null,
});


const mapDispatchToProps = (dispatch) => ({
    getReport: (reportType, config) => dispatch(Actions.getReport(reportType, config)),
    getStudentReport: (reportType, config) => dispatch(Actions.getStudentReport(reportType, config)),
    getProgramByOrganization: organization_id => dispatch(Actions.getProgramByOrganization(organization_id)),
    setLoader: () => dispatch(Actions.setLoader()),
    unsetLoader: () => dispatch(Actions.unsetLoader()),
    getDMFTIndex: (studentId, startNodeId) => dispatch(Actions.getDMFTIndex(studentId, startNodeId))
});


export default connect(mapStateToProps, mapDispatchToProps)(Report)